

export const expOptions = [
    { value: "0-1", label: "0 to 1 Yrs" },
    { value: "1-3", label: "1 to 3 Yrs" },
    { value: "3-5", label: "3 to 5 Yrs" },
    { value: "5-7", label: "5 to 7 Yrs" },
    { value: "7-9", label: "7 to 9 Yrs" },
    { value: "9-12", label: "9 to 12 Yrs" },
    { value: "12-15", label: "12 to 15 Yrs" },
    { value: "15-20", label: "15 to 20 Yrs" },
    { value: "20-25", label: "20 to 25 Yrs" },
    { value: "25-30", label: "25 to 30 Yrs" },
    { value: "30+", label: "Above 30 Yrs" },
];